module.exports = __webpack_public_path__ + "img/分配最优供应商ico.37bc0da6.png";